/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useLayoutEffect, useEffect } from "react";

/**
 * useIsomorphicLayoutEffect: useLayoutEffect for server-side rendering. useLayoutEffect does not run on the server because there's no window,
 * so we can just SSR with a useEffect which won't execute anything (since useEffects run on mount, which happens on the client) but will
 * prevent the very load console warning from showing up. Then we switch to useLayoutEffect on the client where it will actually execute as
 * expected, and won't cause any warnings.
 */
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
